import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { ITreatmentCategory } from '@app/salon-details/models/treatment-category.model';
import { DownPaymentType } from '@app/shared/enums/down-payment-type.enum';
import { ITreatmentApiModel } from '@app/shared/models/treatment-api.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-treatment-category',
  templateUrl: './treatment-category.component.html',
  styleUrls: ['./treatment-category.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule]
})
export class TreatmentCategoryComponent {
  @Input() category: ITreatmentCategory;
  @Input() salon: ISalonDetailsApi;
  @Input() isOnlineBookingTurnedOn: boolean;
  @Input() isMultipleTreatmentsBookingTurnedOn: boolean;
  @Input() categoryIndex: number;
  @Output() treatmentBookClicked = new EventEmitter<ITreatmentApiModel[]>();
  @Output() treatmentShowDescriptionClicked = new EventEmitter<ITreatmentApiModel>();
  @Output() multipleTreatmentsClicked = new EventEmitter<{ event: Event; selectedTreatment: ITreatmentApiModel }>();
  public downPaymentType = DownPaymentType;

  public bookTreatment(selectedTreatmentsToBook: ITreatmentApiModel | ITreatmentApiModel[]): void {
    const selectedTreatments = Array.isArray(selectedTreatmentsToBook) ? selectedTreatmentsToBook : [selectedTreatmentsToBook];
    this.treatmentBookClicked.emit(selectedTreatments);
  }

  public showTreatmentDescription(selectedTreatment: ITreatmentApiModel): void {
    this.treatmentShowDescriptionClicked.emit(selectedTreatment);
  }

  public bookMultipleTreatments(event, selectedTreatment: ITreatmentApiModel): void {
    this.multipleTreatmentsClicked.emit({ event, selectedTreatment });
  }
}
